import { createEffect } from "effector";
import { handleAxiosError } from "../../../shared/lib/error/handleAxiosError";
import axios from "axios";


export const authLoginFx = createEffect(async (
    { username, password }: { username: string, password: string }
) => {
	try {
		await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/login/`, { username, password });
	}
	catch (error: unknown) {
		handleAxiosError(error);
	}
})
